module.exports = __webpack_public_path__ + "static/img/11.61ff8855.png";